import { Text } from '@chakra-ui/react';

import { withConfirm } from 'shared-components/lib/components/formInputs/withConfirm';
import { SectionCard, Section, ItemValidity } from 'shared-components/lib/components/finance/FundingSections';

import { FundingSummary } from '../../../types';
import { dependantChildrenLabel } from '../../../utilities/sponsors';

export enum CoverStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
  UNKNOWN = 'UNKNOWN'
}

interface IProps {
  label: string;
  fundingSummary: FundingSummary;
  coverStatus: {
    courseFees: CoverStatus;
    studentLivingCost: CoverStatus;
    spouseLivingCost: CoverStatus;
    childrenLivingCost: CoverStatus;
  };
}

function getItemValidity(status: CoverStatus) {
  switch (status) {
    case CoverStatus.VALID:
      return true;
    case CoverStatus.INVALID:
      return false;
    case CoverStatus.UNKNOWN:
      return false;
  }
}

function FundingCoverView(props: IProps) {
  const { label, coverStatus } = props;
  const { courseFees, studentLivingCost, spouseLivingCost, childrenLivingCost } = props.fundingSummary;

  function renderCourseFee() {
    if (courseFees.length === 0) return null;

    return (
      <Section title="Course Fee">
        {courseFees.map((fund, i) => (
          <ItemValidity key={i} label={fund.label} isValid={getItemValidity(coverStatus.courseFees)} />
        ))}
      </Section>
    );
  }

  function renderStudentLivingCost() {
    if (studentLivingCost.amount === 0) return null;

    return (
      <Section title="Your Living Cost">
        <ItemValidity label={studentLivingCost.label} isValid={getItemValidity(coverStatus.studentLivingCost)} />
      </Section>
    );
  }

  function renderDependantLivingCost() {
    if (spouseLivingCost.amount === 0 && childrenLivingCost.amount === 0) return null;

    return (
      <Section title="Dependant's Living Cost">
        {spouseLivingCost.amount !== 0 ? (
          <ItemValidity label="Partner" isValid={getItemValidity(coverStatus.spouseLivingCost)} />
        ) : null}

        {childrenLivingCost.amount !== 0 ? (
          <ItemValidity
            label={dependantChildrenLabel(childrenLivingCost.number)}
            isValid={getItemValidity(coverStatus.childrenLivingCost)}
          />
        ) : null}
      </Section>
    );
  }

  return (
    <>
      <Text color="muted">{label}</Text>

      <SectionCard data-selector="funding-cover-view">
        {renderCourseFee()}
        {renderStudentLivingCost()}
        {renderDependantLivingCost()}
      </SectionCard>
    </>
  );
}

export default withConfirm(FundingCoverView);
